import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, TypographyTagVariants } from '@components/atoms/Typography';
import { Container } from '@components/atoms/Container';
import { Footer } from '@components/molecules/Footer';
import { Header } from '@components/molecules/Header';
import notFound from '@assets/images/404.svg';
import notFoundMobile from '@assets/images/404-mobile.svg';
import styles from './maintenancePage.module.css';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { SITE_URLS } from '@constants';

export const MaintenancePage: FC = () => {
    const { t } = useTranslation();

    const translations = {
        metaTitle: t('maintenance-component.metatags.title'),
        description: t('maintenance-component.metatags.description'),
        title: t('maintenance-component.message.title'),
        subtitle: t('maintenance-component.message.subtitle'),
        imageAlt: t('maintenance-component.image.alt'),
    };

    useSEOMetatags({
        title: translations.metaTitle,
        description: translations.description,
        url: SITE_URLS.pageNotFound,
        index: false,
    });

    return (
        <div className={`page ${styles.pageNotFound}`}>
            <Header mode="logo-only" />
            <Container classes="d-flex flex-grow-1 justify-content-center">
                <div className="d-flex flex-row w-100">
                    <div className="left-column d-flex flex-column w-50 p-4 justify-content-center">
                        <img src={notFound} alt={translations.imageAlt} className={`${styles['notfound-img']} mx-auto`} />
                        <img
                            src={notFoundMobile}
                            alt={translations.imageAlt}
                            className={`${styles['notfound-img-mobile']} mx-auto`}
                        />
                    </div>
                    <div className="right-column d-flex flex-column justify-content-center w-50">
                        <Typography classes={`${styles.error} lh-sm mt-4`} fontWeight="900" color="primary">
                            500
                        </Typography>
                        <Typography
                            classes={`${styles.title} lh-sm mb-3`}
                            color="dark"
                            fontWeight="900"
                            fontSize="14"
                            breakpointsStyles={{ md: { fontSize: '36' } }}>
                            {translations.title}
                        </Typography>
                        <Typography
                            classes={`${styles.subtitle} lh-sm mb-1`}
                            tagVariant={TypographyTagVariants.span}
                            fontWeight="900"
                            fontSize="14"
                            breakpointsStyles={{ md: { fontSize: '18' } }}
                            color="dark">
                            <>{translations.subtitle}</>
                        </Typography>
                    </div>
                </div>
            </Container>
            <Footer mode="short" />
        </div>
    );
};
